import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close'; // Import the Close icon
import CloseIcon from '@mui/icons-material/Close';





function AlertCard() {
    const jobData = [
        { title: 'UI UX Designer', type: 'FullTime', date: 'All', experience: '2 Years', level: 'Officer', jobsFound: 21, time: 'Daily' },
        { title: 'Graphic Designer', type: 'FullTime', date: 'All', experience: '2 Years', level: 'Officer', jobsFound: 8, time: 'Weekly' },
        { title: 'Developer', type: 'FullTime', date: 'All', experience: '2 Years', level: 'Officer', jobsFound: 12, time: 'Daily' }
    ];

    return (
        <section className="account-section pt-1">
            <div className="container " style={{ marginBottom: '50px' }}>
                <div className="content-wrapper" >
                    <div className="title delete-title">
                        <h1><span className="orange-box"></span> Alert Jobs</h1>
                    </div>

                    <div className="card Alertcard">
                        <div className="search-container">
                            {/* Search input */}
                            <div className="search-bar Alertsearch">
                                <SearchIcon className="search-icon" />
                                <input type="texts" placeholder="Search Jobs..." className="search-input" />
                            </div>

                            {/* Dropdown */}
                            <div className="dropdown-container Alertdrop-container">
                                <select className="dropdowns AlertDrop">
                                    <option value="default">Sort by Default</option>
                                    <option value="date">Sort by Date</option>
                                    <option value="relevance">Sort by Relevance</option>
                                </select>
                            </div>
                        </div>



                        <div className="job-alerts-container">
                            <table className="job-alerts">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Alert Query</th>
                                        <th>Number Jobs</th>
                                        <th>Times</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobData.map((job, index) => (
                                        <tr key={index} className={'highlight-row'}>
                                            <td>{job.title}</td>
                                            <td>
                                                <div>Type: {job.type}</div>
                                                <div>Posted Date: {job.date}</div>
                                                <div>Experience: {job.experience}</div>
                                                <div>Career Level: {job.level}</div>
                                            </td>
                                            <td>Jobs found {job.jobsFound}</td>
                                            <td className="time-column">
                                                <span>{job.time}</span>
                                            </td>
                                            <td className="time-column">
                                                <CloseIcon className="close-icon" />

                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>





                    </div>
                </div>
            </div>
        </section>
    );
}

export default AlertCard;
